import axios from "@/utils/request.js";
import qs from "qs"
// 获取推荐列表
const getrecommend = (params) => axios({
    url: "/api/web-operate/study/center/lesson/recommend/page",
    method: 'get',
    params
})

// 获取最新列表
const getNewest = (params) => axios({
    url: "/api/web-operate/study/center/lesson/newest/page",
    method: 'get',
    params
})

// 查询全部课程分类列表
const getCategory = (params) => axios({
    url: "/api/web-operate/study/center/category/list",
    method: 'get',
    params
})

// 分页获取已发布系列列表
const getPublished = (params) => axios({
    url: "/api/web-operate/study/center/series/published/page",
    method: 'get',
    params
})

// 获取系列详情
const getSeriesDetail = (params) => axios({
    url: "/api/web-operate/study/center/series/detail",
    method: 'get',
    params
})

// 获取课程详情
const getLessonDetail = (params) => axios({
    url: "/api/web-operate/study/center/lesson/detail",
    method: 'get',
    params
})

// 分页获取我的学习课程列表
const getMineLesson = (params) => axios({
    url: "/api/web-operate/study/center/mine/lesson",
    method: 'get',
    params
})

// 分页获取我参与的答题列表
const getMineExercise = (params) => axios({
    url: "/api/web-operate/study/center/mine/exercise",
    method: 'get',
    params
})

// 章节视频学习记录
const postObjectRecord = (params) => axios({
    url: "/api/web-operate/study/center/object/record",
    method: 'post',
    params
})

// 获取学习时长，单位：秒
const getDuration = (params) => axios({
    url: "/api/web-operate/study/center/duration",
    method: 'get',
    params
})

// 分页获取今日排行
const getTodayList = (params) => axios({
    url: "/api/web-operate/study/center/rank/today",
    method: 'get',
    params
})

// 分页获取总排行
const getTotalList = (params) => axios({
    url: "/api/web-operate/study/center/rank/total",
    method: 'get',
    params
})
// 获取置顶课程列表
const getLessonList = (params) => axios({
    url: "/api/web-operate/study/center/lesson/top/list",
    method: 'get',
    params
})

// 练习答题学习记录
const postExerciseRecord = (params) => axios({
    url: "/api/web-operate/study/center/exercise/record",
    method: 'post',
    params
})


export {
    getrecommend,
    getNewest,
    getCategory,
    getPublished,
    getSeriesDetail,
    getLessonDetail,
    getMineLesson,
    getMineExercise,
    postObjectRecord,
    getDuration,
    getTodayList,
    getTotalList,
    getLessonList,
    postExerciseRecord
}